"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@emotion/react");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  align-self: center;\n  justify-self: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// We need to set override to flex-start otherwise height: auto causes the icon to
// stretch inside flexboxes on Safari/Webkit
var icon = (0, _react.css)(_templateObject());
var _default = icon;
exports["default"] = _default;